import { render, staticRenderFns } from "./fromdialog.vue?vue&type=template&id=08679527&scoped=true&"
import script from "./fromdialog.vue?vue&type=script&lang=js&"
export * from "./fromdialog.vue?vue&type=script&lang=js&"
import style0 from "./fromdialog.vue?vue&type=style&index=0&id=08679527&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08679527",
  null
  
)

export default component.exports